import { PickUpInStoreType } from './type'
import Visual from './Visual'

const PickUpInStore = ({ shipping, services }: PickUpInStoreType) => {
  return <Visual shipping={shipping} services={services}/>
}

export default PickUpInStore
